import React from "react";
import { useTranslation } from "react-i18next";

export function ContactPage() {
    const { t } = useTranslation();
    return (
        <div data-testid="contact-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <h1 className="font-heading font-black text-4xl md:text-5xl mb-6">{t("static.contact_title")}</h1>
            <div className="bento-card p-6 md:p-8 space-y-4 text-foreground/90 leading-relaxed">
                <p>{t("static.contact_body")}</p>
                <div className="p-4 rounded-xl bg-muted">
                    <p className="text-sm font-semibold">Email</p>
                    <a href={`mailto:${t("static.contact_email")}`} className="text-lg font-bold underline">
                        {t("static.contact_email")}
                    </a>
                </div>
                <div className="p-4 rounded-xl bg-muted">
                    <p className="text-sm font-semibold">Phone Call or Whatsapp</p>
                    <a href={`tel:${t("static.contact_phone")}`} className="text-lg font-bold underline">
                        {t("static.contact_phone")}
                    </a>
                </div>
            </div>
        </div>
    );
}

export function AboutPage() {
    const { t } = useTranslation();
    return (
        <StaticPage testId="about-page" title={t("static.about_title")} body={t("static.about_body")} />
    );
}

export function TermsPage() {
    const { t } = useTranslation();
    return <StaticPage testId="terms-page" title={t("static.terms_title")} body={t("static.terms_body")} />;
}

export function PrivacyPage() {
    const { t } = useTranslation();
    return <StaticPage testId="privacy-page" title={t("static.privacy_title")} body={t("static.privacy_body")} />;
}

export function RefundPolicyPage() {
    const { t } = useTranslation();
    return (
        <StaticPage testId="refund-page" title={t("static.refund_title")} body={t("static.refund_body")} />
    );
}

const StaticPage = ({ title, body, testId }) => (
    <div data-testid={testId} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1 className="font-heading font-black text-4xl md:text-5xl mb-6">{title}</h1>
        <div className="bento-card p-6 md:p-8 whitespace-pre-wrap text-foreground/90 leading-relaxed">
            {body}
        </div>
    </div>
);
